// extracted by mini-css-extract-plugin
module.exports = {"spinner":"spinnerStyles-module--spinner--36hW4","spin":"spinnerStyles-module--spin--3S1Ji"};